export default "__VITE_ASSET__CfpeRsYX__"